// This icon file is generated automatically.
var TimeFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10 20a10 10 0 110-20 10 10 0 010 20zm-.23-8.84V6.28a.7.7 0 00-1.4 0v5.58c0 .39.31.7.7.7h5.58a.7.7 0 100-1.4H9.77z" } }] }, "name": "time", "theme": "filled" };
export default TimeFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/TimeFilled.js
// module id = 4258
// module chunks = 0